import { useRef, useEffect, useState } from 'react';
import PalmerSectionLabel from './PalmerSectionLabel';

const awards = [
  {
    count: '27x',
    name: 'Awwwards',
    desc: 'Recognized for bold interaction, structured visual rhythm, and design consistency across creative categories.',
    imgs: [
      'https://framerusercontent.com/images/5QMl4IurwLvQ40GhcE9evVfTQW0.png',
      'https://framerusercontent.com/images/TGpbpkV9gbzPz61ATQTzIwpBBPU.jpg',
      'https://framerusercontent.com/images/41QaDdGvmS3kEQL4oJyWQuJz8.png',
      'https://framerusercontent.com/images/dfa6kXeZNdp07AUexK86lC0Av1Q.png',
    ],
  },
  {
    count: '14x',
    name: 'FWA',
    desc: 'Awarded for outstanding execution, seamless animation, and originality in modern digital experiences.',
    imgs: [
      'https://framerusercontent.com/images/PxLb8BDiVT7EGmdeXqCrY6sAc.png',
      'https://framerusercontent.com/images/aPQiidta60oegcTH3cTfAPygffo.png',
      'https://framerusercontent.com/images/J1Q74WRyFPKRGnwpdricaO9Ad0.png',
      'https://framerusercontent.com/images/7zDvQk8tt3iZmAn51N2mbMG6pM.png',
    ],
  },
  {
    count: '09x',
    name: 'CSSDA',
    desc: 'Celebrated for front-end excellence, design innovation, and development precision across multiple showcases.',
    imgs: [
      'https://framerusercontent.com/images/XNRYGgOFhpafGTgRg64oNix1dc.png',
      'https://framerusercontent.com/images/Z2NHZ6NBGhRJSliWFhlR4dZSSA8.png',
      'https://framerusercontent.com/images/higLDZKTZifAO3UujqIIRQCVTM.png',
      'https://framerusercontent.com/images/JR6gofaz38J5kX4BQiMcn7nob4.png',
    ],
  },
  {
    count: '08x',
    name: 'Dribbble',
    desc: 'Highlighted for strong typographic systems, visual hierarchy, and thoughtful layout built with intent.',
    imgs: [
      'https://framerusercontent.com/images/vhHIJv4PmmgQ1TXOzia8Qs7b5g.png',
      'https://framerusercontent.com/images/GsvUhduUuKpqabW4bstAZkXg2I.png',
      'https://framerusercontent.com/images/gSYRlBgpTRIsra86H4SkUPaCm4E.png',
      'https://framerusercontent.com/images/jA1qpVSmkaG1iOloC5NZWxJfofQ.png',
    ],
  },
];

export default function PalmerAwards() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.05 });
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-black py-20">
      <PalmerSectionLabel left1="© Awards アワード" left2="(WDX® — 08)" right="Selected Honors" />
      <div className="px-6">
        <div className="flex items-end gap-3 mb-10">
          <h2
            className={`text-white font-semibold transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 'clamp(48px, 7.5vw, 110px)', letterSpacing: '-0.04em', lineHeight: 1 }}
          >
            Awards
          </h2>
          <span className="text-white/30 font-semibold mb-2" style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 'clamp(22px, 3vw, 48px)', letterSpacing: '-0.03em' }}>(4)</span>
        </div>
        <div>
          {awards.map((award, i) => (
            <div
              key={award.name}
              className={`border-t border-white/10 py-6 grid grid-cols-1 lg:grid-cols-12 gap-6 transition-all duration-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="lg:col-span-1"><p className="text-white/35 text-xs" style={{ fontFamily: "'DM Sans', sans-serif" }}>{award.count}</p></div>
              <div className="lg:col-span-2"><p className="text-white text-sm font-medium" style={{ fontFamily: "'DM Sans', sans-serif" }}>{award.name}</p></div>
              <div className="lg:col-span-5"><p className="text-white/35 text-xs leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>{award.desc}</p></div>
              <div className="lg:col-span-4 flex items-center gap-2">
                {award.imgs.map((img, j) => (
                  <div key={j} className="overflow-hidden flex-1" style={{ height: 80 }}>
                    <img src={img} alt="" className="w-full h-full object-cover object-top" />
                  </div>
                ))}
              </div>
            </div>
          ))}
          <div className="border-t border-white/10"></div>
        </div>
      </div>
    </section>
  );
}
